import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { getSectorIcon } from '../../utils/sectorIcons';

const toNepaliNumber = (num) => {
  const nepaliDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
  return String(num ?? 0).replace(/[0-9]/g, (digit) => nepaliDigits[digit]);
};

const SectorCard = ({ sector, language = 'ne' }) => {
  if (!sector) return null;

  const IconComponent = getSectorIcon(sector);

  // Determine subsector count dynamically from tags/subSectors
  const count = Array.isArray(sector.tags)
    ? sector.tags.length
    : Array.isArray(sector.subSectors)
    ? sector.subSectors.length
    : typeof sector.subSectorsCount === 'number'
    ? sector.subSectorsCount
    : typeof sector.subRegions === 'number'
    ? sector.subRegions
    : 0;

  const title = language === 'ne'
    ? (sector.nepaliTitle || sector.name || sector.title || '')
    : (sector.title || sector.name || sector.nepaliTitle || '');

  const description = language === 'ne'
    ? (sector.nepaliDescription || sector.description || '')
    : (sector.description || sector.nepaliDescription || '');

  const subSectorLabel = language === 'ne'
    ? `${toNepaliNumber(count)} उप-क्षेत्रहरू`
    : `${count} Sub-sectors`;

  const priorityAreaLabel = language === 'ne' ? 'विकास क्षेत्र' : 'PRIORITY AREA';
  const ctaText = language === 'ne' ? 'विस्तारमा जानुहोस्' : 'Explore Details';
  const slug = sector.slug || sector._id || sector.id || '';

  return (
    <Link
      to={`/sector/${encodeURIComponent(slug)}`}
      className="sector-card"
      aria-label={`${title}: ${description}`}
    >
      {/* Top Header: Icon Container + Label + Top-Right Action Arrow */}
      <div className="sector-card__header">
        <div className="sector-card__badge-wrapper">
          <div className="sector-card__icon-box" aria-hidden="true">
            <IconComponent size={22} strokeWidth={1.9} />
          </div>
          <span className="sector-card__area-label">{priorityAreaLabel}</span>
        </div>
        <div className="sector-card__corner-arrow" aria-hidden="true">
          <ArrowUpRight size={16} />
        </div>
      </div>

      {/* Main Body: Title & Description */}
      <div className="sector-card__body">
        <h3 className="sector-card__title">{title}</h3>
        <p className="sector-card__description">{description}</p>
      </div>

      {/* Footer: Dynamic Subsectors Pill & Animated CTA */}
      <div className="sector-card__footer">
        <div className="sector-card__meta">
          <span className="sector-card__subsectors-pill">
            {subSectorLabel}
          </span>
        </div>
        <span className="sector-card__cta">
          <span>{ctaText}</span>
          <ArrowRight size={15} className="sector-card__cta-icon" />
        </span>
      </div>
    </Link>
  );
};

export default SectorCard;
